

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BaseUrl } from "../../Helper/BaseUrl";
import { toastErrorr, toastSuccesss } from "../../Helper/ToastMessage";

// Get Table Data
export const CommWorkAssignedTableDataAPI = createAsyncThunk("CommWorkAssignedTableDataAPI", async ({ data }) => {
    const {
        FromDate,
        ToDate,
        M_WardID,
        WorkAssignByM_UserID,
        M_AssetTypeID,
        M_AssetID,
        M_GD_WorkPeriodID,
        M_UsersID,
        Flag,
        ShowBy,
        From,
        To,
        M_ContractorID,
        M_ZoneID ,
        token
    } = data

    var myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
    };
    return fetch(`${BaseUrl}/APKDashboard/Get_WEB_GD_T_UploadAssignWorkOfficerWisePeriod_Select?FromDate=${FromDate}&ToDate=${ToDate}&M_WardID=${M_WardID}&M_ZoneID=${M_ZoneID}&WorkAssignByM_UserID=${WorkAssignByM_UserID}&M_AssetTypeID=${M_AssetTypeID}&M_AssetID=${M_AssetID}&M_GD_WorkPeriodID=${M_GD_WorkPeriodID}&M_UsersID=${M_UsersID}&Flag=${Flag}&ShowBy=${ShowBy}&From=${From}&To=${To}&M_ContractorID=${M_ContractorID}`, requestOptions)
        .then((res) => res.json())
        .then((result) => {
            if (result.code >= 200 && result.code <= 300 && result.data) {
                return result.data
            } else {
                return result
            }
        })
})

const CommWorkAssignedTableDataAPISlice = createSlice({
    name: "CommWorkAssignedTableDataAPI",
    initialState: {
        isLoading: false,
        tableData: null,
        isError: false,
    },
    extraReducers: (builder) => {
        builder.addCase(CommWorkAssignedTableDataAPI.pending, (state, action) => {
            state.isLoading = true;
        });
        builder.addCase(CommWorkAssignedTableDataAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.tableData = action.payload;
        });
        builder.addCase(CommWorkAssignedTableDataAPI.rejected, (state, action) => {
            console.log("Error", action.payload);
            state.isLoading = false;
            state.isError = true;
            state.tableData = null;
            toastErrorr('Something went wrong')
        });
    },
})

export const CommWorkAssignedTableDataAPIReducer = CommWorkAssignedTableDataAPISlice.reducer